import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Form, FormControl } from "react-bootstrap";
import WhatsAppAPI from "../../api/WhatsAppAPI";
import { toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import * as constants from "../../constants/CONSTANT";

const TemplatePreview = ({
  template,
  onParametersChange,
  tamplateparms,
  setParameters,
  parameters,
}) => {
  const [userInfo] = useState(() => {
    try {
      const token = sessionStorage.getItem("token");
      return token ? jwt_decode(token) : {};
    } catch {
      return {};
    }
  });

  const getHeaderUrl = (headerBody) => {
    if (!headerBody) return "";
    if (headerBody.startsWith("http") && !headerBody.includes("/public/")) {
      return headerBody;
    }
    let filename = headerBody;
    if (headerBody.includes("/")) {
      filename = headerBody.split("/").pop();
    }
    return `${constants.API_BASE_URL}/api/whatsapp/files/preview/${userInfo.tenantcode || "demo"}/${filename}`;
  };
  // console.log("🚀 ~ template:", template);
  //const [parameters, setParameters] = useState({});
  const [sendToAdmin, setSendToAdmin] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileURL, setSelectedFileURL] = useState(null);
  const [selectedFileType, setSelectedFileType] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const docxIcon = "/user_images/doc-icon.png";
  const fileInputRef = useRef(null);

  // Use a single allParams state for all parameters/files
  const [allParams, setAllParams] = useState({});
  useEffect(() => {
    setAllParams({});
  }, [template]);

  // Main body input change
  const handleMainParamChange = (paramIdx, value) => {
    setAllParams((prev) => {
      const updated = {
        ...prev,
        main: {
          ...(prev.main || {}),
          [paramIdx]: value,
        },
      };
      onParametersChange(updated);
      return updated;
    });
  };
  // Per-card input change
  const handleCardParamChange = (cardIdx, paramIdx, value) => {
    setAllParams((prev) => {
      const updated = {
        ...prev,
        [cardIdx]: {
          ...(prev[cardIdx] || {}),
          [paramIdx]: value,
        },
      };
      onParametersChange(updated);
      return updated;
    });
  };
  // Per-card file change
  const handleCardFileChange = async (cardIdx, event, headerType) => {
    const file = event.target.files[0];
    if (!file) return;

    const quota = await WhatsAppAPI.checkStorageQuota();
    if (quota.exceeded) {
      toast.error("Storage limit reached! Please delete some attachments or buy more space.");
      event.target.value = null;
      return;
    }
    // Validate file type/size (reuse logic as below, but per card)
    let allowedExtensions = [];
    let maxSize = 0;
    if (headerType === "IMAGE") {
      allowedExtensions = ["image/jpeg", "image/png"];
      maxSize = 5 * 1024 * 1024;
    } else if (headerType === "VIDEO") {
      allowedExtensions = ["video/mp4", "video/3gpp"];
      maxSize = 16 * 1024 * 1024;
    } else if (headerType === "DOCUMENT") {
      allowedExtensions = [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/3gpp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain",
      ];
      maxSize = 100 * 1024 * 1024;
    }
    if (!allowedExtensions.includes(file.type)) {
      alert(`Invalid file type for card ${cardIdx + 1}`);
      return;
    }
    if (file.size > maxSize) {
      alert(`File size exceeds limit for card ${cardIdx + 1}`);
      return;
    }
    setAllParams((prev) => {
      const updated = {
        ...prev,
        [cardIdx]: {
          ...(prev[cardIdx] || {}),
          file,
          fileURL: URL.createObjectURL(file),
          fileType: headerType.toLowerCase(),
        },
      };
      onParametersChange(updated);
      return updated;
    });
  };
  // Send to admin checkbox (single, correct version)

  useEffect(() => {
    setParameters({});
    setSendToAdmin(false);
    setSelectedFile(null);
    setSelectedFileType(null);
    setErrorMessage("");

    setSelectedFileURL(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    // Ensure default fileType is sent when template changes
    onParametersChange({
      sendToAdmin: false,
      file: null,
    });
  }, [template]);
  //useEffect(() => {
  //  setParameters({});
  //
  //  if (tamplateparms && typeof tamplateparms === "object") {
  //    const { sendToAdmin, file, file_id, whatsapp_number_admin, ...restParameters } = tamplateparms;
  //
  //    setSendToAdmin(sendToAdmin);
  //    setSelectedFile(file);
  //    setParameters(restParameters);
  //  }
  //
  //}, [tamplateparms]);
  useEffect(() => {
    //setParameters({});

    if (tamplateparms && typeof tamplateparms === "object") {
      const {
        sendToAdmin,
        file,
        file_id,
        whatsapp_number_admin,
        ...restParameters
      } = tamplateparms;

      setSendToAdmin(sendToAdmin);
      setParameters({
        ...restParameters,
        file: file || null,
      });

      if (file) {
        setSelectedFile(file);
        if (file instanceof Blob || file instanceof File) {
          setSelectedFileType(file.type);
          setSelectedFileURL(URL.createObjectURL(file));
        } else {
          setSelectedFileType(file.type || "");
          setSelectedFileURL(file.url || "");
        }
      }
    }
  }, [tamplateparms]);

  /** Tooltip: show resolved value - phone_number, full URL (with {{1}} replaced), or button text */
  const getButtonTooltip = (button, buttonVariables) => {
    if (!button) return "";
    if (button.type === "PHONE_NUMBER" && button.phone_number) {
      return button.phone_number;
    }
    if (button.type === "URL" && button.url) {
      let url = (button.url || "").toString();
      const matches = url.match(/\{\{(\d+)\}\}/g);
      if (matches) {
        matches.forEach((m) => {
          const variableIndex = m.replace(/\{\{|\}\}/g, "");
          const value =
            buttonVariables?.[variableIndex] ??
            buttonVariables?.[String(variableIndex)] ??
            button.example?.[0] ??
            m;
          url = url.replace(m, value);
        });
      }
      return url;
    }
    return button.text || "";
  };

  // Helper function to format text with parameters and preserve formatting
  const formatTextWithParameters = (text, paramsObj) => {
    if (!text) return "";
    let formattedText = text;

    // Replace parameter placeholders
    Object.keys(paramsObj).forEach((key) => {
      const placeholder = `{{${key}}}`;
      const replacement = (paramsObj[key] || "").toString();
      formattedText = formattedText.replace(
        new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
        replacement,
      );
    });

    return formattedText;
  };

  if (!template) {
    return (
      <div className="whatsapp-background">
        Please select a template to preview.
      </div>
    );
  }

  if (template.template_type === "carousel" && Array.isArray(template.cards)) {
    // Handle per-card parameter change
    const handleCardParamChange = (cardIdx, paramIdx, value) => {
      setAllParams((prev) => {
        const updated = {
          ...prev,
          [cardIdx]: {
            ...prev[cardIdx],
            [paramIdx]: value,
          },
        };
        onParametersChange(updated);
        return updated;
      });
    };
    // Handle per-card file change
    const handleCardFileChange = async (cardIdx, event, headerType) => {
      const file = event.target.files[0];
      if (!file) return;

      const quota = await WhatsAppAPI.checkStorageQuota();
      if (quota.exceeded) {
        toast.error("Storage limit reached! Please delete some attachments or buy more space.");
        event.target.value = null;
        return;
      }
      // Validate file type/size (reuse logic as below, but per card)
      let allowedExtensions = [];
      let maxSize = 0;
      if (headerType === "IMAGE") {
        allowedExtensions = ["image/jpeg", "image/png"];
        maxSize = 5 * 1024 * 1024;
      } else if (headerType === "VIDEO") {
        allowedExtensions = ["video/mp4", "video/3gpp"];
        maxSize = 16 * 1024 * 1024;
      } else if (headerType === "DOCUMENT") {
        allowedExtensions = [
          "image/jpeg",
          "image/png",
          "video/mp4",
          "video/3gpp",
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-powerpoint",
          "application/vnd.openxmlformats-officedocument.presentationml.presentation",
          "text/plain",
        ];
        maxSize = 100 * 1024 * 1024;
      }
      if (!allowedExtensions.includes(file.type)) {
        alert(`Invalid file type for card ${cardIdx + 1}`);
        return;
      }
      if (file.size > maxSize) {
        alert(`File size exceeds limit for card ${cardIdx + 1}`);
        return;
      }
      setAllParams((prev) => {
        const updated = {
          ...prev,
          [cardIdx]: {
            ...prev[cardIdx],
            file,
            fileURL: URL.createObjectURL(file),
            fileType: headerType.toLowerCase(),
          },
        };
        onParametersChange(updated);
        return updated;
      });
    };
    const handleCheckboxChange = (event) => {
      const checked = event.target.checked;
      setSendToAdmin(checked);
      onParametersChange({
        ...parameters,
        sendToAdmin: checked,
        file: selectedFile,
      });
    };
    return (
      <div className="container-fluid p-4">
        <div className="row">
          {(() => {
            const hasParamsInBody = /\{\{([^}]+)\}\}/g.test(
              template.message_body || "",
            );
            const hasParamsInCards = Array.isArray(template.cards)
              ? template.cards.some(
                  (card) =>
                    typeof card.body_text === "string" &&
                    /\{\{([^}]+)\}\}/g.test(card.body_text),
                )
              : false;

            if (hasParamsInBody || hasParamsInCards) {
              return (
                <div className="mb-3 text-primary">
                  💡 Tip: Write <code>name</code> as a parameter to replace it
                  with the real name of the client.
                </div>
              );
            }
            return null;
          })()}

          {/* Left: Inputs for all cards and main body */}
          <div className="col-md-6">
            {/* Main body curly-brace inputs */}

            {template.message_body && (
              <div className="mb-4 p-2 border rounded bg-light">
                <div className="mb-2 fw-bold">Main Message Body Variables</div>
                {(() => {
                  const matches =
                    template.message_body.match(/\{\{([^}]+)\}\}/g);
                  if (!matches || matches.length === 0) {
                    return (
                      <div className="mb-2 text-muted">
                        No curly-brace parameters in this template's message
                        body.
                      </div>
                    );
                  }

                  return matches.map((match) => {
                    const paramIndex = match.replace(/\{\{|\}\}/g, "");
                    return (
                      <div key={paramIndex} className="mb-2">
                        <label className="form-label fw-bold">
                          Enter value for &#123;&#123;{paramIndex}&#125;&#125;:
                        </label>
                        <Form.Group
                          controlId={`formInputMainBody_${paramIndex}`}
                        >
                          <FormControl
                            type="text"
                            value={
                              (allParams.main && allParams.main[paramIndex]) ||
                              ""
                            }
                            required
                            onChange={(e) =>
                              handleMainParamChange(paramIndex, e.target.value)
                            }
                            placeholder={`Value for {{${paramIndex}}}`}
                            className="p-2"
                            aria-required="true"
                          />
                        </Form.Group>
                      </div>
                    );
                  });
                })()}
              </div>
            )}
            {Array.isArray(template.cards) &&
              template.cards.map((card, idx) => {
                // Defensive: ensure body_text is a string
                let bodyText =
                  typeof card.body_text === "string" ? card.body_text : "";
                if (!bodyText) {
                  console.warn(
                    `Card ${
                      idx + 1
                    } is missing body_text or it is not a string`,
                    card,
                  );
                }
                // Find curly-brace params in card body (support any identifier, not just digits)
                const matches = bodyText.match(/\{\{([^}]+)\}\}/g) || [];
                const uniqueIndices = [
                  ...new Set(matches.map((m) => m.replace(/\{\{|\}\}/g, ""))),
                ];
                const params = allParams[idx] || {};
                return (
                  <div key={idx} className="mb-4 p-2 border rounded bg-light">
                    <div className="mb-2 fw-bold">Card {idx + 1}</div>
                    {/* Per-card file upload */}
                    {card.header_type !== "TEXT" && (
                      <div className="mb-2">
                        <label className="form-label fw-bold">
                          Upload File:
                        </label>
                        <input
                          type="file"
                          className="form-control border rounded"
                          onChange={(e) =>
                            handleCardFileChange(idx, e, card.header_type)
                          }
                        />
                        {params.file && (
                          <div className="mt-1">
                            <span className="text-muted">
                              {params.file.name}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                    {/* Per-card parameter inputs */}
                    {uniqueIndices.length === 0 && (
                      <div className="mb-2 text-muted">
                        No curly-brace parameters in this card's body text.
                      </div>
                    )}
                    {uniqueIndices.map((paramIndex) => (
                      <div key={paramIndex} className="mb-2">
                        <label className="form-label fw-bold">
                          Enter value for &#123;&#123;{paramIndex}&#125;&#125;:
                        </label>
                        <Form.Group
                          controlId={`formInputCard${idx}_${paramIndex}`}
                        >
                          <FormControl
                            type="text"
                            value={params[paramIndex] || ""}
                            required
                            onChange={(e) =>
                              handleCardParamChange(
                                idx,
                                paramIndex,
                                e.target.value,
                              )
                            }
                            placeholder={`Value for {{${paramIndex}}}`}
                            className="p-2"
                            aria-required="true"
                          />
                        </Form.Group>
                      </div>
                    ))}
                  </div>
                );
              })}
            {/* Send to Admin Checkbox (if needed for carousel) */}
          </div>
          {/* Right: Preview only */}
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <div className="whatsapp-background w-100">
              <div className="template-box">
                {/* Main message body */}
                <div className="template-content mt-3 mb-3">
                  {template.message_body}
                </div>
                {/* Carousel cards preview only */}
                <div
                  style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                    paddingBottom: 16,
                  }}
                >
                  {template.cards.map((card, idx) => {
                    const params = allParams[idx] || {};
                    return (
                      <div
                        key={idx}
                        style={{
                          display: "inline-block",
                          width: 340,
                          marginRight: 16,
                          verticalAlign: "top",
                        }}
                      >
                        <div
                          className="card shadow-sm"
                          style={{ minHeight: 350 }}
                        >
                          <div className="card-body">
                            {/* Card header preview (with uploaded file if present) */}
                            {params.fileURL && params.fileType === "image" && (
                              <img
                                src={params.fileURL}
                                alt="Uploaded Preview"
                                className="img-fluid rounded w-100 mb-2"
                                style={{ height: "120px", objectFit: "cover" }}
                              />
                            )}
                            {params.fileURL && params.fileType === "video" && (
                              <video
                                src={params.fileURL}
                                controls
                                className="img-fluid rounded w-100 mb-2"
                                style={{ height: "120px", objectFit: "cover" }}
                              />
                            )}
                            {params.fileURL &&
                              params.fileType === "document" && (
                                <a
                                  href={params.fileURL}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={docxIcon}
                                    alt="Document Thumbnail"
                                    className="img-fluid rounded w-100 mb-2"
                                    style={{
                                      height: "120px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </a>
                              )}
                            {!params.fileURL &&
                              card.header_type === "IMAGE" &&
                              card.header_image_url && (
                                <img
                                  src={getHeaderUrl(card.header_image_url)}
                                  alt="Card"
                                  className="img-fluid rounded w-100 mb-2"
                                  style={{
                                    height: "120px",
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                            {!params.fileURL &&
                              card.header_type === "VIDEO" &&
                              card.header_video_url && (
                                <video
                                  src={getHeaderUrl(card.header_video_url)}
                                  controls
                                  className="img-fluid rounded w-100 mb-2"
                                  style={{
                                    height: "120px",
                                    objectFit: "cover",
                                  }}
                                />
                              )}
                            {!params.fileURL &&
                              card.header_type === "DOCUMENT" &&
                              card.header_document_url && (
                                <a
                                  href={getHeaderUrl(card.header_document_url)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <img
                                    src={docxIcon}
                                    alt="Document Thumbnail"
                                    className="img-fluid rounded w-100 mb-2"
                                    style={{
                                      height: "120px",
                                      objectFit: "cover",
                                    }}
                                  />
                                </a>
                              )}
                            {!params.fileURL &&
                              card.header_type === "TEXT" &&
                              card.header_text && (
                                <strong>{card.header_text}</strong>
                              )}
                            {/* Card body text with curly-brace param preview */}
                            <div
                              style={{
                                minHeight: 48,
                                fontWeight: 500,
                                fontSize: "1rem",
                                color: "#222",
                                padding: "8px 0",
                                background: "#f8f9fa",
                                borderRadius: "4px",
                                wordBreak: "break-word",
                                marginTop: "8px",
                                whiteSpace: "pre-wrap",
                                lineHeight: "1.5",
                              }}
                            >
                              {formatTextWithParameters(card.body_text, params)}
                            </div>
                            {/* Card body text examples */}
                            {card.body_text_example &&
                              card.body_text_example.length > 0 && (
                                <div className="mb-2">
                                  <strong>Examples:</strong>
                                  <ul style={{ paddingLeft: 18 }}>
                                    {card.body_text_example.map((ex, i) => (
                                      <li key={i}>{ex}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            {/* Buttons */}
                            <div className="template-buttons mt-3 d-flex flex-column gap-2">
                              {card.buttons &&
                                card.buttons.map((button, bidx) => (
                                  <div
                                    key={bidx}
                                    className="btn btn-outline-secondary btn-sm mb-2"
                                    title={getButtonTooltip(
                                      button,
                                      parameters?.button_variables,
                                    )}
                                  >
                                    {button.text}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const handleInputChange = (index, value) => {
    const newParams = { ...parameters, [index]: value };
    setParameters(newParams);
    onParametersChange({ ...newParams, sendToAdmin, file: selectedFile });
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    setSendToAdmin(checked);
    onParametersChange({
      ...parameters,
      sendToAdmin: checked,
      file: selectedFile,
    });
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const quota = await WhatsAppAPI.checkStorageQuota();
    if (quota.exceeded) {
      toast.error("Storage limit reached! Please delete some attachments or buy more space.");
      if (fileInputRef.current) fileInputRef.current.value = "";
      event.target.value = null;
      return;
    }

    const fileType = file.type;
    const fileSize = file.size;

    // Determine allowed extensions based on template.header
    let allowedExtensions = [];
    let maxSize = 0;

    if (template.header === "IMAGE") {
      allowedExtensions = ["image/jpeg", "image/png"];
      maxSize = 5 * 1024 * 1024; // 5MB
    } else if (template.header === "VIDEO") {
      allowedExtensions = ["video/mp4", "video/3gpp"];
      maxSize = 16 * 1024 * 1024; // 16MB
    } else if (template.header === "DOCUMENT") {
      allowedExtensions = [
        "image/jpeg",
        "image/png",
        "video/mp4",
        "video/3gpp",
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "text/plain",
      ];
      maxSize = 100 * 1024 * 1024; // 100MB
    }

    // Validate file type
    if (!allowedExtensions.includes(fileType)) {
      setErrorMessage(
        `Invalid file type. Please upload a valid ${template.header.toLowerCase()}.`,
      );
      return;
    }

    // Validate file size
    if (fileSize > maxSize) {
      setErrorMessage(
        `File size exceeds the limit (${maxSize / (1024 * 1024)}MB).`,
      );
      return;
    }

    setErrorMessage("");

    // Determine file type category
    let fileCategory = fileType.includes("image")
      ? "image"
      : fileType.includes("video")
        ? "video"
        : "document";

    setSelectedFile(file);
    setSelectedFileType(fileCategory);
    setSelectedFileURL(URL.createObjectURL(file));
    // Pass the file and its type to parent
    onParametersChange({ ...parameters, sendToAdmin, file });
  };

  const renderFormattedMessage = () => {
    let formattedText = template?.message_body || "";

    // First, escape HTML special characters
    formattedText = formattedText
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

    // Replace parameter placeholders with parameter values
    Object.keys(parameters).forEach((key) => {
      const placeholder = `{{${key}}}`;
      const replacement = (parameters[key] || "").toString();
      // Escape the replacement value too
      const escapedReplacement = replacement
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
      formattedText = formattedText.replace(
        new RegExp(placeholder.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), "g"),
        escapedReplacement,
      );
    });

    // Replace newlines with <br /> tags
    formattedText = formattedText.replace(/\n/g, "<br />");
    // Handle bold text (after escaping HTML)
    formattedText = formattedText.replace(/\*(.*?)\*/g, "<strong>$1</strong>");

    return (
      <div
        style={{
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          lineHeight: "1.5",
        }}
        dangerouslySetInnerHTML={{ __html: formattedText }}
      />
    );
  };

  const getHeader = () => {
    if (selectedFileURL) {
      if (selectedFileType && selectedFileType.includes("image")) {
        return (
          <img
            src={selectedFileURL}
            alt="Uploaded Preview"
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      } else if (selectedFileType && selectedFileType.includes("video")) {
        return (
          <video
            src={selectedFileURL}
            controls
            className="img-fluid rounded w-100 mb-2"
            style={{ height: "200px", objectFit: "cover" }}
          />
        );
      } else if (selectedFileType) {
        return (
          <a href={selectedFileURL} target="_blank" rel="noopener noreferrer">
            <img
              src={docxIcon}
              alt="Document Thumbnail"
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          </a>
        );
      }
    }

    if (template?.header && template?.header_body) {
      const resolvedHeaderUrl = getHeaderUrl(template.header_body);
      switch (template.header) {
        case "IMAGE":
          return (
            <img
              src={resolvedHeaderUrl}
              alt="Template Header"
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          );
        case "VIDEO":
          return (
            <video
              src={resolvedHeaderUrl}
              controls
              className="img-fluid rounded w-100 mb-2"
              style={{ height: "200px", objectFit: "cover" }}
            />
          );
        case "DOCUMENT":
          return (
            <a
              href={resolvedHeaderUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={docxIcon}
                alt="Document Thumbnail"
                className="img-fluid rounded w-100 mb-2"
                style={{ height: "200px", objectFit: "cover" }}
              />
            </a>
          );
        default:
          return <strong>{template.header_body}</strong>;
      }
    }

    return null;
  };

  const getFooter = () =>
    template.footer ? (
      <div className="template-footer text-muted">{template.footer}</div>
    ) : null;

  const getButtons = () => {
    if (template.buttons && template.buttons.length > 0) {
      const quickReplyButtons = template.buttons.filter(
        (button) => button.type === "QUICK_REPLY",
      );
      const otherButtons = template.buttons.filter(
        (button) => button.type !== "QUICK_REPLY",
      );

      return (
        <div className="template-buttons mt-3 d-flex flex-column gap-2">
          {otherButtons.map((button, index) => (
            <div
              key={index}
              className="btn btn-outline-secondary btn-sm mb-2"
              title={getButtonTooltip(button, parameters?.button_variables)}
            >
              {button.text}
            </div>
          ))}
          {quickReplyButtons &&
            quickReplyButtons.map((button, index) => (
              <div
                key={index}
                className="btn btn-outline-secondary btn-sm mb-2"
                title={getButtonTooltip(button, parameters?.button_variables)}
              >
                {button.text}
              </div>
            ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="container-fluid p-4">
      <div className="row">
        <div className="col-md-6">
          {/* File Upload Input */}
          {/*{template.header && template.header_body && template.header !== 'TEXT'  &&
            <div className="mb-3">
            <label className="form-label fw-bold">Upload File:</label>
            <input type="file" className="form-control border rounded" onChange={handleFileChange}  ref={fileInputRef} />
            {errorMessage && <div className="text-danger mt-2">{errorMessage}</div>}
          </div>
          }*/}

          {template.header &&
            template.header_body &&
            template.header !== "TEXT" && (
              <div className="mb-3">
                <label className="form-label fw-bold">Upload File:</label>
                <input
                  type="file"
                  className="form-control border rounded"
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />

                {selectedFile && (
                  <div className="mt-2">
                    <p className="text-muted">{selectedFile.name}</p>
                  </div>
                )}

                {errorMessage && (
                  <div className="text-danger mt-2">{errorMessage}</div>
                )}
              </div>
            )}

          {(() => {
            const matches = template.message_body.match(/\{\{([^}]+)\}\}/g);
            if (matches && matches.length > 0) {
              return (
                <div className="my-2 text-primary">
                  💡 Tip: Write <code>name</code> as a parameter to replace it
                  with the real name of the client.
                </div>
              );
            }
            return null; // nothing will show if no parameters
          })()}

          {/* Parameters */}
          {(() => {
            const matches =
              template?.message_body?.match(/\{\{(\d+)\}\}/g) || [];
            const uniqueIndices = [
              ...new Set(
                matches.map((match) => match.replace(/\{\{|\}\}/g, "")),
              ),
            ];

            return uniqueIndices.map((paramIndex, idx) => (
              <div key={idx} className="mb-3">
                <label className="form-label fw-bold">
                  Enter value for &#123;&#123;{paramIndex}&#125;&#125;:
                </label>
                <Form.Group controlId={`formInput${paramIndex}`}>
                  <FormControl
                    type="text"
                    inputMode={
                      template?.category === "AUTHENTICATION"
                        ? "numeric"
                        : "text"
                    }
                    pattern={
                      template?.category === "AUTHENTICATION"
                        ? "\\d{6}"
                        : undefined
                    }
                    maxLength={
                      template?.category === "AUTHENTICATION" ? 6 : undefined
                    }
                    value={parameters[paramIndex] || ""}
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      if (template?.category === "AUTHENTICATION") {
                        if (/^\d{0,6}$/.test(value)) {
                          handleInputChange(paramIndex, value);
                        }
                      } else {
                        handleInputChange(paramIndex, value);
                      }
                    }}
                    placeholder={`Value for {{${paramIndex}}}`}
                    className="p-3"
                    aria-required="true"
                  />
                </Form.Group>
              </div>
            ));
          })()}

          {/* Send to Admin Checkbox */}
        </div>

        <div className="col-md-6 d-flex justify-content-center align-items-center">
          <div className="whatsapp-background w-100">
            <div className="template-box">
              {getHeader()}
              <div className="template-content mt-3">
                {renderFormattedMessage()}
                {getFooter()}
                {getButtons()}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplatePreview;
